const COUNTRY_COOKIE_NAME = 'selectedCountry';
const COOKIE_EXPIRY_DAYS = 30;

function normalizeCultureCode(value: string): string | null {
    const match = value.trim().match(/^\/?([a-z]{2})(?:\/|$)/i);
    return match && match[1] ? match[1].toLowerCase() : null;
}

export function setCookie(name: string, value: string, days: number): void {
    if (typeof document === 'undefined') {
        return;
    }
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}

export function setSelectedCountry(cultureOrPath: string): void {
    const cultureCode = normalizeCultureCode(cultureOrPath);
    if (!cultureCode) {
        return;
    }
    setCookie(COUNTRY_COOKIE_NAME, cultureCode, COOKIE_EXPIRY_DAYS);
}

export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') {
        return null;
    }
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
        const trimmed = cookie.trim();
        if (trimmed.startsWith(nameEQ)) {
            return trimmed.substring(nameEQ.length);
        }
    }
    return null;
}

export function getSelectedCountry(): string | null {
    return getCookie(COUNTRY_COOKIE_NAME);
}

export function clearSelectedCountry(): void {
    if (typeof document === 'undefined') {
        return;
    }
    document.cookie = `${COUNTRY_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}
